import React, { useState, useEffect } from 'react';

const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const isInStandaloneMode = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showNative, setShowNative] = useState(false);
  const [showIOS, setShowIOS] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('beezy-install-dismissed')) return;
    if (isInStandaloneMode()) return;

    // iOS: no beforeinstallprompt, show manual instructions
    if (isIOS()) {
      setShowIOS(true);
      return;
    }

    // Chrome/Android: use native install prompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowNative(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowNative(false);
  };

  const handleDismiss = () => {
    localStorage.setItem('beezy-install-dismissed', 'true');
    setShowNative(false);
    setShowIOS(false);
  };

  if (!showNative && !showIOS) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 flex justify-center animate-toast-in">
      <div className="flex items-center gap-3 px-5 py-3 glass rounded-xl shadow-glass-lg max-w-md w-full">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-700 dark:text-gray-200">
            Add Beezy to Home Screen
          </p>
          {showIOS ? (
            <p className="text-xs text-gray-400 dark:text-gray-500">
              Tap{' '}
              <svg
                className="inline w-4 h-4 -mt-0.5 text-blue-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                />
              </svg>{' '}
              then &ldquo;Add to Home Screen&rdquo;
            </p>
          ) : (
            <p className="text-xs text-gray-400 dark:text-gray-500">Quick access anytime</p>
          )}
        </div>
        {showNative && (
          <button
            onClick={handleInstall}
            className="px-4 py-1.5 bg-honey-500 text-white text-sm font-medium rounded-full hover:bg-honey-600 transition-colors"
          >
            Install
          </button>
        )}
        <button
          onClick={handleDismiss}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
          aria-label="Dismiss"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
